import React from 'react';
import UiEmptyState from '../ui/EmptyState';

/**
 * Legacy empty-state wrapper — maps old prop names to Acme `EmptyState`.
 * Prefer `import { EmptyState } from '../ui'`.
 */
const EmptyState = ({
  icon: IconComponent,
  title,
  description,
  subtitle,
  hint,
  actionButton,
  action,
  sx = {},
  ...rest
}) => (
  <UiEmptyState
    icon={IconComponent}
    title={title}
    description={description}
    hint={hint ?? subtitle}
    action={action ?? actionButton}
    sx={sx}
    {...rest}
  />
);

export default EmptyState;
